import en from 'vee-validate/dist/locale/en.json';

export default {
  ...en.messages,
  required: 'Required',
  numeric: 'Only numbers',
  email: 'Enter valid email',
  type: `Supported file types: {value}`,
  size: `File size should be less than {value}Mb`,
  sumSize: `Total files size should be less than {value}Mb`,
  notLaterToday: "Can't be greater than the current date",
};
